import styled from 'styled-components';

export const ContainerForm = styled.form`
  display: flex;
  flex-direction: column;
  flex: none;
  width: 100vw;
  font-family: 'Libre Franklin', sans-serif;
  align-items: center;
`;

export const TitleForm = styled.div`
  display: flex;
  flex-direction: column;
  flex: none;
  width: 89.333vw;
  font-family: 'Libre Franklin', sans-serif;
  align-items: flex-start;

  p {
    font-size: 5.866vw;
    font-weight: 700;
    margin: 5.093vw 0 1.6vw 0;
  }
  span {
    font-size: 3.733vw;
    font-weight: 400;
    margin: 0 0 5.333vw 0;
    width: 82.133vw;
  }
`;

export const ErrorMsg = styled.p<{ visibility: string }>`
  color: red;
  font-family: 'Libre Franklin', sans-serif;
  font-size: 4.468vw !important;
  font-weight: 700;
  text-align: center;
  margin-top: -2.5vw;
  visibility: ${(props) => props.visibility};
  z-index: 3;
`;

export const SideBySide = styled.div`
  display: flex;
  flex: none;
  width: 89.333vw;
  align-items: flex-end;
  justify-content: space-between;
  background-color: transparent;
`;

export const ButtonContinue = styled.button`
  font-family: 'Outfit', sans-serif;
  font-size: 4.266vw;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  color: #ffffff;
  width: 89.333vw;
  height: 13.333vw;
  border: 1px solid #000000;
  border-radius: 2.666vw;
  margin-top: 2vw;
  background-color: #000000;
  cursor: pointer;
  flex: none;

  &:disabled {
    cursor: not-allowed;
    background-color: #efefef;
    border: none;
  }
`;
